import { useState } from 'react';
import Editor from 'react-simple-wysiwyg';

export default function WysiwygEditor({data, action}) {


    const [html, setHtml] = useState(data);

    function onChange(e) {
        setHtml(e.target.value);

        if (action) {
            action(e.target.value)
        }
    }

    return <Editor containerProps={{ style: { resize: 'vertical' } }} value={html} onChange={onChange} />
    
}